import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  class: "navbar navbar-light navbar-expand-md bg-light",
  role: "navigation"
}
const _hoisted_5 = { class: "form-inline mr-2" }
const _hoisted_6 = { class: "btn-group" }
const _hoisted_7 = { class: "dropdown-menu" }
const _hoisted_8 = { class: "form-inline mr-auto" }
const _hoisted_9 = { class: "btn-group" }
const _hoisted_10 = {
  key: 0,
  type: "button",
  class: "btn btn-outline-primary btn-sm dropdown-toggle",
  "data-toggle": "dropdown"
}
const _hoisted_11 = { class: "dropdown-menu" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "text-muted px-4 mb-1 font-italic d-block"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  class: "form-inline my-2 my-lg-0",
  role: "search"
}
const _hoisted_17 = { class: "card-deck" }
const _hoisted_18 = { class: "card" }
const _hoisted_19 = { class: "card-body" }
const _hoisted_20 = { class: "card-title" }
const _hoisted_21 = { class: "text-ellipsis fg-color-gray mb-0 mt-1" }
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = ["title"]
const _hoisted_24 = { class: "text-muted" }
const _hoisted_25 = {
  key: 0,
  class: "m-0"
}
const _hoisted_26 = {
  key: 1,
  class: "dropdown"
}
const _hoisted_27 = {
  class: "text-primary",
  "data-toggle": "dropdown"
}
const _hoisted_28 = {
  class: "dropdown-menu",
  style: {"max-height":"300px","overflow-y":"auto"}
}
const _hoisted_29 = { class: "container-fluid" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 2,
  class: "text-muted px-4 mb-1 font-italic d-block"
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = {
  key: 0,
  class: "text-muted px-4 mb-1 font-italic d-block"
}
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "card" }
const _hoisted_43 = { class: "card-body" }
const _hoisted_44 = { class: "card-title" }
const _hoisted_45 = { class: "text-ellipsis fg-color-gray mb-0 mt-1" }
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = ["title"]
const _hoisted_48 = { class: "text-muted" }
const _hoisted_49 = {
  key: 0,
  class: "m-0"
}
const _hoisted_50 = {
  key: 1,
  class: "dropdown"
}
const _hoisted_51 = {
  class: "text-primary",
  "data-toggle": "dropdown"
}
const _hoisted_52 = {
  class: "dropdown-menu",
  style: {"max-height":"300px","overflow-y":"auto"}
}
const _hoisted_53 = { class: "container-fluid" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "col-md-6" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = {
  key: 0,
  class: "text-muted px-4 mb-1 font-italic d-block"
}
const _hoisted_58 = ["onClick"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { class: "col-md-6" }
const _hoisted_61 = {
  key: 0,
  class: "text-muted px-4 mb-1 font-italic d-block"
}
const _hoisted_62 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CriterionScaleEditor = _resolveComponent("CriterionScaleEditor")!
  const _component_DiscreteScaleEditor = _resolveComponent("DiscreteScaleEditor")!
  const _component_AttributeEditorDialog = _resolveComponent("AttributeEditorDialog")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!
  const _component_GoalNavigation = _resolveComponent("GoalNavigation")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_CriterionScaleEditor, {
      viewModel: _ctx.criterionScaleEditor,
      onAssignCustomScale: _ctx.handleAssignCustomScaleMeasurementCommand
    }, null, 8 /* PROPS */, ["viewModel", "onAssignCustomScale"]),
    _createVNode(_component_DiscreteScaleEditor, {
      viewModel: _ctx.discreteScaleEditor,
      onCreateScale: _ctx.handleCreateWorkspaceScaleCommand
    }, null, 8 /* PROPS */, ["viewModel", "onCreateScale"]),
    _createVNode(_component_AttributeEditorDialog, {
      viewModel: _ctx.attributeEditorDialog,
      onNumericAttributeCreated: _ctx.numericAttributeCreated
    }, null, 8 /* PROPS */, ["viewModel", "onNumericAttributeCreated"]),
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.Initialized)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_2, [...(_cache[10] || (_cache[10] = [
            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
            _createTextVNode(" Loading... ", -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true),
      (_ctx.Initialized)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[37] || (_cache[37] = _createElementVNode("a", {
              class: "btn btn-outline-secondary float-right",
              href: "https://www.transparentchoice.com/user-guide/build-criteria",
              title: "User guide: Build criteria",
              target: "_blank"
            }, [
              _createElementVNode("i", {
                class: "fa fa-info",
                "aria-hidden": "true"
              })
            ], -1 /* CACHED */)),
            _createElementVNode("h3", null, "Goal: " + _toDisplayString(_ctx.rm.GoalName), 1 /* TEXT */),
            _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createVNode(_component_GoalNavigation, {
              WorkspaceId: _ctx.workspaceId,
              ProjectId: _ctx.projectId,
              EvalModelId: _ctx.evalModelId,
              ActivePage: 'measurement',
              ScoringEnabled: _ctx.rm.ScoringEnabled
            }, null, 8 /* PROPS */, ["WorkspaceId", "ProjectId", "EvalModelId", "ScoringEnabled"]),
            _createElementVNode("nav", _hoisted_4, [
              _createElementVNode("form", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.NoneCriteriaSelected)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-outline-secondary btn-sm",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectAll && _ctx.selectAll(...args)))
                      }, [...(_cache[11] || (_cache[11] = [
                        _createElementVNode("i", { class: "fa-regular fa-square" }, null, -1 /* CACHED */)
                      ]))]))
                    : _createCommentVNode("v-if", true),
                  (_ctx.AnyCriteriaSelected && !_ctx.AllCriteriaSelected)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-outline-secondary btn-sm",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.unselectAll && _ctx.unselectAll(...args)))
                      }, [...(_cache[12] || (_cache[12] = [
                        _createElementVNode("i", { class: "fa-regular fa-square-minus" }, null, -1 /* CACHED */)
                      ]))]))
                    : _createCommentVNode("v-if", true),
                  (_ctx.AllCriteriaSelected)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        type: "button",
                        class: "btn btn-outline-secondary btn-sm",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.unselectAll && _ctx.unselectAll(...args)))
                      }, [...(_cache[13] || (_cache[13] = [
                        _createElementVNode("i", { class: "fa-regular fa-square-check" }, null, -1 /* CACHED */)
                      ]))]))
                    : _createCommentVNode("v-if", true),
                  _cache[14] || (_cache[14] = _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-secondary btn-sm dropdown-toggle dropdown-toggle-split",
                    "data-toggle": "dropdown"
                  }, null, -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.selectAll && _ctx.selectAll(...args)))
                    }, "All"),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.unselectAll && _ctx.unselectAll(...args)))
                    }, "None"),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.inverseSelection && _ctx.inverseSelection(...args)))
                    }, "Inverse")
                  ])
                ])
              ]),
              _createElementVNode("form", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.AnyCriteriaSelected)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_10, "Set measurement"))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[16] || (_cache[16] = _createElementVNode("h6", { class: "dropdown-header" }, "Survey based", -1 /* CACHED */)),
                    (_ctx.ScalesTemplates == null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[15] || (_cache[15] = [
                          _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                          _createTextVNode(" Loading scales ", -1 /* CACHED */)
                        ]))]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          (_ctx.ScalesTemplates.length === 0)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_14, "You don't have any scales templates yet."))
                            : _createCommentVNode("v-if", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ScalesTemplates, (st) => {
                            return (_openBlock(), _createElementBlock("a", {
                              key: st.Id,
                              class: "dropdown-item",
                              onClick: ($event: any) => (_ctx.handleBulkAssignScaleTemplateMeasurementCommandV1(st))
                            }, _toDisplayString(st.Name), 9 /* TEXT, PROPS */, _hoisted_15))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])),
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleBulkAssignPairwiseMeasurementCommand && _ctx.handleBulkAssignPairwiseMeasurementCommand(...args)))
                    }, "Pairwise comparisons")
                  ])
                ])
              ]),
              _createElementVNode("form", _hoisted_16, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.SearchPhrase) = $event)),
                  class: "form-control form-control-sm mr-sm-2",
                  type: "search",
                  placeholder: "Search"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.SearchPhrase]
                ])
              ])
            ]),
            _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("h5", _hoisted_20, [
                    _cache[20] || (_cache[20] = _createTextVNode("Survey based ", -1 /* CACHED */)),
                    _createElementVNode("small", null, [
                      _cache[18] || (_cache[18] = _createTextVNode("(", -1 /* CACHED */)),
                      _createElementVNode("a", {
                        class: "text-primary",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showWorkspaceScaleCreator(null)))
                      }, "create scale template"),
                      _cache[19] || (_cache[19] = _createTextVNode(")", -1 /* CACHED */))
                    ])
                  ]),
                  _cache[26] || (_cache[26] = _createElementVNode("p", { class: "text-muted" }, "Collect Data by asking respondents to rate alternatives - ideal for capturing experts' opinions & stakeholders' points of view.", -1 /* CACHED */)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SurveyBased, (c) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: c.CriterionId,
                      class: "tile rounded-0 mx-0 mt-0 mb-3"
                    }, [
                      _createElementVNode("p", _hoisted_21, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((c.IsSelected) = $event)
                        }, null, 8 /* PROPS */, _hoisted_22), [
                          [_vModelCheckbox, c.IsSelected]
                        ]),
                        _createElementVNode("span", {
                          title: c.Name
                        }, _toDisplayString(c.Name), 9 /* TEXT, PROPS */, _hoisted_23)
                      ]),
                      _createElementVNode("small", _hoisted_24, _toDisplayString(c.Path), 1 /* TEXT */),
                      _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      (c.Loading)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_25, [...(_cache[21] || (_cache[21] = [
                            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */)
                          ]))]))
                        : _createCommentVNode("v-if", true),
                      (!c.Loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("a", _hoisted_27, _toDisplayString(c.MeasurementLabel), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("div", _hoisted_31, [
                                    _cache[23] || (_cache[23] = _createElementVNode("h6", { class: "dropdown-header" }, "Survey based", -1 /* CACHED */)),
                                    (c.HasScale)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                          _createElementVNode("a", {
                                            class: "dropdown-item",
                                            onClick: ($event: any) => (_ctx.showCriterionScaleEditor(c))
                                          }, "Edit scale", 8 /* PROPS */, _hoisted_33),
                                          _createElementVNode("a", {
                                            class: "dropdown-item",
                                            onClick: ($event: any) => (_ctx.showWorkspaceScaleCreator(c))
                                          }, "Save as scale template", 8 /* PROPS */, _hoisted_34),
                                          _createElementVNode("a", {
                                            class: "dropdown-item",
                                            onClick: ($event: any) => (_ctx.handleAssignPairwiseMeasurementCommand(c))
                                          }, "Pairwise comparisons", 8 /* PROPS */, _hoisted_35),
                                          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */))
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    (!c.HasScale)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 1,
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (_ctx.showCriterionScaleEditor(c))
                                        }, "Custom scale", 8 /* PROPS */, _hoisted_36))
                                      : _createCommentVNode("v-if", true),
                                    (_ctx.ScalesTemplates.length === 0)
                                      ? (_openBlock(), _createElementBlock("small", _hoisted_37, " You don't have any scales templates yet. "))
                                      : _createCommentVNode("v-if", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ScalesTemplates, (st) => {
                                      return (_openBlock(), _createElementBlock("a", {
                                        key: st.DiscreteScaleId,
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.handleAssignScaleTemplateMeasurementCommandV1(c, st))
                                      }, _toDisplayString(st.Name), 9 /* TEXT, PROPS */, _hoisted_38))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ]),
                                  _createElementVNode("div", _hoisted_39, [
                                    _cache[24] || (_cache[24] = _createElementVNode("h6", { class: "dropdown-header" }, "Attribute based", -1 /* CACHED */)),
                                    (_ctx.Attributes.length === 0)
                                      ? (_openBlock(), _createElementBlock("small", _hoisted_40, "You don't have any attributes yet."))
                                      : _createCommentVNode("v-if", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Attributes, (attr) => {
                                      return (_openBlock(), _createElementBlock("a", {
                                        key: attr.Id,
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.handleAssignAttributeMeasurementCommand(c, attr.Id))
                                      }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_41))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("h5", _hoisted_44, [
                    _cache[29] || (_cache[29] = _createTextVNode("Attribute based ", -1 /* CACHED */)),
                    _createElementVNode("small", null, [
                      _cache[27] || (_cache[27] = _createTextVNode("(", -1 /* CACHED */)),
                      _createElementVNode("a", {
                        class: "text-primary",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.showAttributeCreator && _ctx.showAttributeCreator(...args)))
                      }, "create attribute"),
                      _cache[28] || (_cache[28] = _createTextVNode(")", -1 /* CACHED */))
                    ])
                  ]),
                  _cache[35] || (_cache[35] = _createElementVNode("p", { class: "text-muted" }, "Collect Data via a Form - ideal for using the output from existing models, hard data, or a subjective rating from a single source.", -1 /* CACHED */)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.AttributeBased, (c) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: c.CriterionId,
                      class: "tile rounded-0 mx-0 mt-0 mb-3"
                    }, [
                      _createElementVNode("p", _hoisted_45, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((c.IsSelected) = $event)
                        }, null, 8 /* PROPS */, _hoisted_46), [
                          [_vModelCheckbox, c.IsSelected]
                        ]),
                        _createElementVNode("span", {
                          title: c.Name
                        }, _toDisplayString(c.Name), 9 /* TEXT, PROPS */, _hoisted_47)
                      ]),
                      _createElementVNode("small", _hoisted_48, _toDisplayString(c.Path), 1 /* TEXT */),
                      _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      (c.Loading)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_49, [...(_cache[30] || (_cache[30] = [
                            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */)
                          ]))]))
                        : _createCommentVNode("v-if", true),
                      (!c.Loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                            _createElementVNode("a", _hoisted_51, _toDisplayString(c.MeasurementLabel), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("div", _hoisted_53, [
                                _createElementVNode("div", _hoisted_54, [
                                  _createElementVNode("div", _hoisted_55, [
                                    _cache[31] || (_cache[31] = _createElementVNode("h6", { class: "dropdown-header" }, "Survey based", -1 /* CACHED */)),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (_ctx.showCriterionScaleEditor(c))
                                    }, "Custom scale", 8 /* PROPS */, _hoisted_56),
                                    (_ctx.ScalesTemplates.length === 0)
                                      ? (_openBlock(), _createElementBlock("small", _hoisted_57, " You don't have any scales templates yet. "))
                                      : _createCommentVNode("v-if", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ScalesTemplates, (st) => {
                                      return (_openBlock(), _createElementBlock("a", {
                                        key: st.DiscreteScaleId,
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.handleAssignScaleTemplateMeasurementCommandV1(c, st))
                                      }, _toDisplayString(st.Name), 9 /* TEXT, PROPS */, _hoisted_58))
                                    }), 128 /* KEYED_FRAGMENT */)),
                                    _cache[32] || (_cache[32] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (_ctx.handleAssignPairwiseMeasurementCommand(c))
                                    }, "Pairwise comparisons", 8 /* PROPS */, _hoisted_59)
                                  ]),
                                  _createElementVNode("div", _hoisted_60, [
                                    _cache[33] || (_cache[33] = _createElementVNode("h6", { class: "dropdown-header" }, "Attribute based", -1 /* CACHED */)),
                                    (_ctx.Attributes.length === 0)
                                      ? (_openBlock(), _createElementBlock("small", _hoisted_61, "You don't have any attributes yet."))
                                      : _createCommentVNode("v-if", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Attributes, (attr) => {
                                      return (_openBlock(), _createElementBlock("a", {
                                        key: attr.Id,
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.handleAssignAttributeMeasurementCommand(c, attr.Id))
                                      }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_62))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */)),
                  _cache[36] || (_cache[36] = _createElementVNode("div", { class: "alert alert-danger" }, [
                    _createElementVNode("p", null, " NEGATIVE numbers will be rounded to zero in any calculations. Remember, you could use calculated attributes to transform your values so they are all positive. ")
                  ], -1 /* CACHED */))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}